export function TiremetrixSettingsCtrl (
  $state,
  $scope,
  $translate,
  confirm,
  integrations,
  messages,
  quote,
  workshopAPI
) {
  $scope.integrations = integrations;
  $scope.loaded       = true;
  $scope.quote        = quote;

  $scope.settings = {
    has_tiremetrix_tire_registration: integrations.has_tiremetrix_tire_registration,
    tire_registration_username: integrations.tire_registration_username
  };

  $scope.save = function (form) {
    /**
     * it seems that we have duplicate flag and username fields. This should be addressed at some point.
     * there are fields for tire_registration and for tiremetrix even though they seem to handle the same
     * thing.
     */
    $scope.settings.tiremetrix_tpms_username = $scope.settings.tire_registration_username;
    $scope.settings.has_tiremetrix_tpms      = $scope.settings.has_tiremetrix_tire_registration;

    workshopAPI.patch('/company_integrations', $scope.settings, 'company_integration').then(data => {
      messages.show($translate.instant('TIREMETRIX_SPACE.TYRE_REGISTRATION_SETTINGS_SAVED'), 'success');

      $state.reload();
    }).catch(err => {
      messages.error(err);
    });
  };

  $scope.activate = function () {
    confirm.generic($translate.instant('JS_SPACE.INTEGRATIONS.ACTIVATE', { name: 'Tire Registration' })).then(() => {
      return workshopAPI.get('/company_integration/add_tire_registration');
    }).then(() => {
      messages.show($translate.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', { name: 'Tire Registration' }), 'success');

      $state.reload();
    }).catch(err => {
      messages.error(err);
    });
  };

  $scope.remove = function () {
    confirm.generic($translate.instant('JS_SPACE.INTEGRATIONS.REMOVE', { name: 'Tire Registration' })).then(() => {
      return workshopAPI.get('/company_integration/remove_tire_registration')
    }).then(() => {
      messages.show($translate.instant('JS_SPACE.INTEGRATIONS.REMOVED', { name: 'Tire Registration' }), 'success');

      $state.reload();
    }).catch(err => {
      messages.error(err);
    });
  };
}